// Deep-link'и в навигацию для курьера. Ноль запросов к API: координаты берём свои
// (delivery_lat/lon, прошли через DaData), не текстовый адрес.
//
// Яндекс.Навигатор: yandexnavi://build_route_on_map?lat_to=&lon_to=[&lat_via_0=&lon_via_0=...]
// Фолбэк (нет приложения / десктоп): https://yandex.ru/maps/?rtext=~lat,lon[~lat,lon]&rtt=auto
// («~» первой точкой = от текущего местоположения).

export function naviUrl(points) {
  const dest = points[points.length - 1];
  const params = [`lat_to=${dest[0]}`, `lon_to=${dest[1]}`];
  points.slice(0, -1).forEach((p, i) => {
    params.push(`lat_via_${i}=${p[0]}`, `lon_via_${i}=${p[1]}`);
  });
  return `yandexnavi://build_route_on_map?${params.join('&')}`;
}

export function mapsUrl(points) {
  return `https://yandex.ru/maps/?rtext=~${points.map((p) => `${p[0]},${p[1]}`).join('~')}&rtt=auto`;
}

/**
 * points: [[lat, lon], ...] в порядке объезда; последняя — конечная.
 * Deep-link в приложение не уводит вкладку — панель курьера остаётся открытой.
 * Раньше через 1,5 с был авто-редирект текущей вкладки на веб-карты: на iOS, пока висит
 * вопрос «Открыть в приложении?», вкладка не в фоне, таймер срабатывал и панель
 * заменялась Яндекс Картами. Теперь вкладку не трогаем: если приложение не открылось,
 * вызываем onFallback(webUrl) — страница показывает ссылку «Открыть в Яндекс Картах»
 * (новая вкладка по нажатию).
 */
export function openRoute(points, { onFallback } = {}) {
  const pts = (points || []).filter((p) => p && p[0] && p[1]);
  if (!pts.length) return;
  const web = mapsUrl(pts);
  let left = false;
  const onHide = () => { if (document.hidden) left = true; };
  document.addEventListener('visibilitychange', onHide);
  setTimeout(() => {
    document.removeEventListener('visibilitychange', onHide);
    if (!left && !document.hidden && onFallback) onFallback(web);
  }, 2500);
  window.location.href = naviUrl(pts);
}

export function orderPoint(order) {
  return order && order.delivery_lat && order.delivery_lon ? [order.delivery_lat, order.delivery_lon] : null;
}

// Одна точка — по ТЕКСТУ адреса, а не по координатам (решение 30.08): команды маршрута
// принимают только координаты, и Яндекс подписывает нашу точку по своей карте («2а» вместо «2»,
// улица без дома при неточном геокодировании). Поиск по тексту находит дом геокодером Яндекса —
// подпись и дом совпадают с карточкой, курьер нажимает «Поехали». Весь маршрут (много точек)
// так нельзя — там по координатам, курьер сверяется с адресом в карточке.
export function naviSearchUrl(text) {
  return `yandexnavi://map_search?text=${encodeURIComponent(text)}`;
}

export function mapsSearchUrl(text) {
  return `https://yandex.ru/maps/?text=${encodeURIComponent(text)}`;
}

/** Открыть адрес заказа в Навигаторе поиском; без текста адреса — маршрут по координатам. */
export function openAddress(order, { onFallback } = {}) {
  const text = (order && order.delivery_address || '').trim();
  if (!text) { openRoute([orderPoint(order)], { onFallback }); return; }
  const web = mapsSearchUrl(text);
  let left = false;
  const onHide = () => { if (document.hidden) left = true; };
  document.addEventListener('visibilitychange', onHide);
  setTimeout(() => {
    document.removeEventListener('visibilitychange', onHide);
    if (!left && !document.hidden && onFallback) onFallback(web);
  }, 2500);
  window.location.href = naviSearchUrl(text);
}
